import config from 'configuration';
import { getToken } from 'utils/auth';

export const getFileUrl = (fileId) => `${config.apiUrl}/files/${fileId}?accessToken=${getToken()}`;
